module.exports = __webpack_public_path__ + "media/images/design/icon_01-8fe03f575939867acba3820ddfc08d86.svg";